module.exports = __webpack_public_path__ + "static/media/20.d9eb6d9d.JPG";